import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { REPORT_KEYS } from "../queryKeys";
import { executeGroupAction } from "../../../services/reportService";
import { GROUP_MESSAGES } from "../../../utils/reportsMessages";

export function useGroupMutations() {
  const queryClient = useQueryClient();

  const invalidateAll = () =>
    Promise.all([
      queryClient.invalidateQueries({ queryKey: REPORT_KEYS.metadata }),
      queryClient.invalidateQueries({ queryKey: REPORT_KEYS.groups }),
    ]);

  return useMutation({
    mutationFn: ({ action, ...payload }: { action: string; [key: string]: any }) =>
      executeGroupAction(action, payload),
    onSuccess: (_, { action }) => {
      toast.success(GROUP_MESSAGES[action] || "Group operation successful");
      invalidateAll();
    },
    onError: () => toast.error("Operation failed"),
  });
}
